import { render, staticRenderFns } from "./Wp_my_child_member.vue?vue&type=template&id=55e24c75&"
import script from "./Wp_my_child_member.vue?vue&type=script&lang=js&"
export * from "./Wp_my_child_member.vue?vue&type=script&lang=js&"
import style0 from "./Wp_my_child_member.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports